// import { useState } from 'react';
import { Divider } from '@mui/material';
import classes from './ClientFiltersTab.module.scss';
import i18n from '../../../../../utils/i18n';
import TagManager from './components/TagManager';
import TextfieldUnit from '../../../../components/TextfieldUnit';
import {
	servicesTags,
	taxTags,
	industryTags,
	specialTags,
	bankTags,
	invoiceTags,
} from './data/TagsData';
import { useDispatch } from 'react-redux';
import ACTIONS from '../../../../../redux/action';
import IndustryExperienceManager from './components/ExperienceManager';
import InputContext from '../../../../../context/inputContext';
import { useContext, useState, useEffect } from 'react';
import { TaxformInputByCompanyType } from '../../../../../provider/data/providerText';

const ClientFiltersTab = ({ providerData }) => {
	const dispatch = useDispatch();
	const { isChanged, setIsChanged } = useContext(InputContext);
	const [filteredIndustries, setFilteredIndustries] = useState([]);

	useEffect(() => {
		const filteredvalue = providerData.provider_industry_restrictions.filter(
			(industry) => industry.on
		);

		setFilteredIndustries(filteredvalue);
	}, [providerData]);

	const handleCompanyTypeChange = (e) => {
		const companyTypes = {
			singleprimary: false,
			kiva: false,
			kft: false,
			zrt: false,
			civil: false,
		};

		e.forEach((option) => {
			const key = option.id;
			if (companyTypes.hasOwnProperty(key)) {
				companyTypes[key] = option.selected;
			}
		});
		dispatch(
			ACTIONS.updateCompanyObject({
				data: companyTypes,
				stateObject: 'provider_business_filter',
			})
		);
		dispatch(
			ACTIONS.updateNestedObject({
				id: 'iscompleted',
				data: true,
				stateObject: 'provider_onboarding',
				stateObjectID: `clientfilters_flow`,
			})
		);
	};
	const handleTaxChange = (e) => {
		// Get all possible tax forms (old + new)
		const selectedCompanyTypes = providerData.provider_business_filter || {};
		const allTaxForms = {};

		// Initialize with existing values to preserve them
		const existingTaxForms = providerData.provider_vatform_restrictions || {};

		// All possible tax forms (old + new)
		const possibleTaxForms = [
			'kiva', // Liber-profesionist / comerciant individual / Impozit pe venit
			'tao', // Impozit pe profit
			'taxkata', // New: Impozitare în sistem real
			'taxflat', // New: Impozitare la normă de venit
			'taxvszja', // New: Microîntreprindere
		];

		// Initialize with existing values or false
		possibleTaxForms.forEach((taxForm) => {
			allTaxForms[taxForm] = existingTaxForms[taxForm] || false;
		});

		// Update based on user selection
		e.forEach((option) => {
			const key = option.id;
			if (allTaxForms.hasOwnProperty(key)) {
				allTaxForms[key] = option.selected;
			}
		});

		dispatch(
			ACTIONS.updateCompanyObject({
				data: allTaxForms,
				stateObject: 'provider_vatform_restrictions',
			})
		);
		dispatch(
			ACTIONS.updateNestedObject({
				id: 'iscompleted',
				data: true,
				stateObject: 'provider_onboarding',
				stateObjectID: `clientfilters_flow`,
			})
		);
	};

	// Get tax forms that should be shown based on selected company types
	const getAvailableTaxForms = () => {
		const selectedCompanyTypes = providerData.provider_business_filter || {};
		const availableTaxFormIds = new Set();

		// Collect all tax forms for selected company types
		Object.keys(selectedCompanyTypes).forEach((companyType) => {
			if (selectedCompanyTypes[companyType] === true) {
				const taxFormsForType = TaxformInputByCompanyType(companyType);
				taxFormsForType.forEach((taxForm) => {
					availableTaxFormIds.add(taxForm.id);
				});
			}
		});

		// Filter taxTags to only show available tax forms
		return taxTags.filter((tag) => availableTaxFormIds.has(tag.id));
	};

	const handleIndustryChange = (e) => {
		const industryTypes = [
			{ id: 'construction', on: false, value: 0 },
			{ id: 'engineer', on: false, value: 0 },
			{ id: 'vehicle', on: false, value: 0 },
			{ id: 'manufacturing', on: false, value: 0 },
			{ id: 'IT', on: false, value: 0 },
			{ id: 'realestate', on: false, value: 0 },
			{ id: 'retail', on: false, value: 0 },
			{ id: 'wholesale', on: false, value: 0 },
			{ id: 'agriculture', on: false, value: 0 },
			{ id: 'education', on: false, value: 0 },
			{ id: 'art', on: false, value: 0 },
			{ id: 'beauty', on: false, value: 0 },
			{ id: 'medicine', on: false, value: 0 },
			{ id: 'finance', on: false, value: 0 },
			{ id: 'logistics', on: false, value: 0 },
			{ id: 'courier', on: false, value: 0 },
			{ id: 'travel', on: false, value: 0 },
			{ id: 'etrade', on: false, value: 0 },
			{ id: 'startup', on: false, value: 0 },
			{ id: 'lawyer', on: false, value: 0 },
			{ id: 'sport', on: false, value: 0 },
			{ id: 'consultancy', on: false, value: 0 },
			{ id: 'otherservices', on: false, value: 0 },
			{ id: 'other', on: false, value: 0 },
		];

		e.forEach((option) => {
			const key = option.id;
			const industry = industryTypes.find((ind) => ind.id === key);

			if (industry) {
				industry.on = option.selected;
			}
		});
		//console.log(industryTypes, 'industryTypes');
		dispatch(
			ACTIONS.updateCompanyObject({
				data: industryTypes,
				stateObject: 'provider_industry_restrictions',
			})
		);
		dispatch(
			ACTIONS.updateNestedObject({
				id: 'iscompleted',
				data: true,
				stateObject: 'provider_onboarding',
				stateObjectID: `clientfilters_flow`,
			})
		);
	};

	const handleRangeChange = (event, index, id) => {
		let restrArray = providerData.provider_restrictions[id];
		let value = event.target.value;
		// Keep revenue cap at 2000, remove other ceilings
		if (id === 'yearlyrevenue') {
			if (parseInt(event.target.value) <= 2000 || !event.target.value) {
				value = event.target.value;
			} else value = 2000;
		}
		restrArray.splice(index, 1, parseInt(value));
		dispatch(
			ACTIONS.addProviderInfo({
				id: id,
				data: restrArray,
				stateObject: 'provider_restrictions',
			})
		);
	};

	const handleSpecChange = (e) => {
		const specFilterTypes = {
			insideEU: false,
			outsideEU: false,
			newlyfounded: false,
		};

		e.forEach((option) => {
			const key = option.id;
			if (specFilterTypes.hasOwnProperty(key)) {
				specFilterTypes[key] = option.selected;
			}
		});
		console.log(specFilterTypes, 'specFilterTypes');
		dispatch(
			ACTIONS.updateCompanyObject({
				data: specFilterTypes,
				stateObject: 'provider_special_restrictions',
			})
		);
	};

	const handleBankChange = (e) => {
		const bankTypes = [
			{ id: 'opt1', on: false, value: 0 },
			{ id: 'opt2', on: false, value: 0 },
			{ id: 'opt3', on: false, value: 0 },
			{ id: 'opt4', on: false, value: 0 },
			{ id: 'opt5', on: false, value: 0 },
			{ id: 'opt6', on: false, value: 0 },
			{ id: 'opt7', on: false, value: 0 },
			{ id: 'opt8', on: false, value: 0 },
			{ id: 'other', on: false, value: 0 },
		];

		e.forEach((option) => {
			const key = option.id;
			const bank = bankTypes.find((ind) => ind.id === key);

			if (bank) {
				bank.on = option.selected;
			}
		});
		console.log(bankTypes, 'bankTypes');
		dispatch(
			ACTIONS.updateCompanyObject({
				data: bankTypes,
				stateObject: 'provider_banking_filter',
			})
		);
	};

	const handleInvoiceChange = (e) => {
		const invoiceTypes = [
			{ id: 'opt1', on: false, value: 0 },
			{ id: 'opt2', on: false, value: 0 },
			{ id: 'opt3', on: false, value: 0 },
			{ id: 'other', on: false, value: 0 },
		];

		e.forEach((option) => {
			const key = option.id;
			const invoice = invoiceTypes.find((ind) => ind.id === key);

			if (invoice) {
				invoice.on = option.selected;
			}
		});
		console.log(invoiceTypes, 'invoiceTypes');
		dispatch(
			ACTIONS.updateCompanyObject({
				data: invoiceTypes,
				stateObject: 'provider_invoicing_filter',
			})
		);
	};

	return (
		<>
			<div className={classes.profileMainTitle}>
				{i18n.t('provider.companyformfilterssub')}
			</div>
			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('provider.companyformfilters')}
					</div>
				</div>
				<div className={classes.rightColumn}>
					<TagManager
						tagsData={servicesTags}
						groups={[
							i18n.t('provider.highlighted'),
							//i18n.t('provider.furtheroptions'),
						]}
						showGroupTitles={false}
						iconType="general"
						onChange={(e) => {
							handleCompanyTypeChange(e);
							setIsChanged(true);
						}}
						filterObject={providerData.provider_business_filter}
						filterType="object"
					/>
				</div>
			</div>

			<Divider sx={{ margin: '0 18px' }} />

			{getAvailableTaxForms().length > 0 && (
				<>
					<div className={classes.paragraph}>
						<div className={classes.leftColumn}>
							<div className={classes.profileTitle}>
								{i18n.t('provider.taxfilters')}
							</div>
						</div>
						<div className={classes.rightColumn}>
							<TagManager
								key={JSON.stringify(providerData.provider_business_filter)}
								tagsData={getAvailableTaxForms()}
								groups={[i18n.t('provider.taxation')]}
								showGroupTitles={false}
								onChange={(e) => {
									handleTaxChange(e);
									setIsChanged(true);
								}}
								filterObject={providerData.provider_vatform_restrictions}
								filterType="object"
							/>
						</div>
					</div>

					<Divider sx={{ margin: '0 18px' }} />
				</>
			)}

			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('provider.industryfilters')}
					</div>
				</div>
				<div className={classes.rightColumn}>
					<TagManager
						tagsData={industryTags}
						groups={[i18n.t('provider.industries')]}
						showGroupTitles={false}
						onChange={(e) => {
							handleIndustryChange(e);
							setIsChanged(true);
						}}
						filterObject={providerData.provider_industry_restrictions}
						filterType="array"
					/>
				</div>
			</div>

			{filteredIndustries.length > 0 && (
				<>
					{' '}
					<Divider sx={{ margin: '0 18px' }} />
					<div className={classes.paragraph}>
						<div className={classes.leftColumn}>
							<div className={classes.profileTitle}>
								{i18n.t('provider.expertinindustriesfilters')}
							</div>
						</div>
						<div className={classes.rightColumn}>
							<IndustryExperienceManager
								providerData={providerData}
								onChange={(updatedExperience) => {
									dispatch(
										ACTIONS.updateCompanyObject({
											data: updatedExperience,
											stateObject: 'provider_industry_experience',
										})
									);
									dispatch(
										ACTIONS.updateNestedObject({
											id: 'iscompleted',
											data: true,
											stateObject: 'provider_onboarding',
											stateObjectID: `clientfilters_flow`,
										})
									);
									setIsChanged(true);
								}}
							/>
						</div>{' '}
					</div>
				</>
			)}

			<Divider sx={{ margin: '0 18px' }} />

			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('provider.companysizefilters')}
					</div>
				</div>
				<div className={classes.rightColumn}>
					<div className={classes.profileSubTitle}>
						{i18n.t('provider.numberofemployees')}
					</div>
					<div className={classes.companySizeFilters}>
						<TextfieldUnit
							id="noofemployees"
							title={'min'}
							isRequired={true}
							showAsterix={true}
							unit={i18n.t('general.person')}
							value={providerData.provider_restrictions.noofemployees[0]}
							onChange={(event) => {
								handleRangeChange(event, 0, event.target.id);
								setIsChanged(true);
							}}
						/>
						<TextfieldUnit
							id="noofemployees"
							title={'max'}
							isRequired={true}
							showAsterix={true}
							unit={i18n.t('general.person')}
							value={providerData.provider_restrictions.noofemployees[1]}
							onChange={(event) => {
								handleRangeChange(event, 1, event.target.id);
								setIsChanged(true);
							}}
						/>
					</div>
				</div>
			</div>
			<div className={classes.paragraph}>
				<div className={classes.leftColumn}></div>

				<div className={classes.rightColumn}>
					<div className={classes.profileSubTitle}>
						{i18n.t('provider.yearlyrevenue')},{' '}
						<strong>{i18n.t('general.thousand')}</strong>{' '}
						{i18n.t('general.currency')}
					</div>
					<div className={classes.companySizeFilters}>
						<TextfieldUnit
							id="yearlyrevenue"
							title={'min'}
							isRequired={true}
							showAsterix={true}
							unit={`k ${i18n.t('general.currency')}`}
							value={providerData.provider_restrictions.yearlyrevenue[0]}
							onChange={(event) => {
								handleRangeChange(event, 0, event.target.id);
								setIsChanged(true);
							}}
						/>
						<TextfieldUnit
							id="yearlyrevenue"
							title={'max'}
							isRequired={true}
							showAsterix={true}
							unit={`k ${i18n.t('general.currency')}`}
							value={providerData.provider_restrictions.yearlyrevenue[1]}
							onChange={(event) => {
								handleRangeChange(event, 1, event.target.id);
								setIsChanged(true);
							}}
						/>
					</div>
				</div>
			</div>
			<div className={classes.paragraph}>
				<div className={classes.leftColumn}></div>

				<div className={classes.rightColumn}>
					<div className={classes.profileSubTitle}>
						{i18n.t('provider.monthlyincominginvoices')}
					</div>
					<div className={classes.companySizeFilters}>
						<TextfieldUnit
							id="incominginvoices"
							title={'min'}
							isRequired={true}
							showAsterix={true}
							unit={i18n.t('general.piece')}
							value={providerData.provider_restrictions.incominginvoices[0]}
							onChange={(event) => {
								handleRangeChange(event, 0, event.target.id);
								setIsChanged(true);
							}}
						/>
						<TextfieldUnit
							id="incominginvoices"
							title={'max'}
							isRequired={true}
							showAsterix={true}
							unit={i18n.t('general.piece')}
							value={providerData.provider_restrictions.incominginvoices[1]}
							onChange={(event) => {
								handleRangeChange(event, 1, event.target.id);
								setIsChanged(true);
							}}
						/>
					</div>
				</div>
			</div>
			<div className={classes.paragraph}>
				<div className={classes.leftColumn}></div>

				<div className={classes.rightColumn}>
					<div className={classes.profileSubTitle}>
						{i18n.t('provider.monthlyoutgoinginvoices')}
					</div>
					<div className={classes.companySizeFilters}>
						<TextfieldUnit
							id="outgoinginvoices"
							title={'min'}
							isRequired={true}
							showAsterix={true}
							unit={i18n.t('general.piece')}
							value={providerData.provider_restrictions.outgoinginvoices[0]}
							onChange={(event) => {
								handleRangeChange(event, 0, event.target.id);
								setIsChanged(true);
							}}
						/>
						<TextfieldUnit
							id="outgoinginvoices"
							title={'max'}
							isRequired={true}
							showAsterix={true}
							unit={i18n.t('general.piece')}
							value={providerData.provider_restrictions.outgoinginvoices[1]}
							onChange={(event) => {
								handleRangeChange(event, 1, event.target.id);
								setIsChanged(true);
							}}
						/>
					</div>
				</div>
			</div>

			<Divider sx={{ margin: '0 18px' }} />
			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('provider.specialfilters')}
					</div>
				</div>
				<div className={classes.rightColumn}>
					<TagManager
						tagsData={specialTags}
						groups={[i18n.t('provider.special')]}
						showGroupTitles={false}
						onChange={(e) => {
							handleSpecChange(e);
							setIsChanged(true);
						}}
						filterObject={providerData.provider_special_restrictions}
						filterType="object"
					/>
				</div>
			</div>

			<Divider sx={{ margin: '0 18px' }} />

			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('provider.otherfilters')}
					</div>
				</div>
				<div className={classes.rightColumn}>
					<TagManager
						tagsData={bankTags}
						groups={[i18n.t('provider.companysmainbank')]}
						showGroupTitles={true}
						onChange={(e) => {
							handleBankChange(e);
							setIsChanged(true);
						}}
						filterObject={providerData.provider_banking_filter}
						filterType="array"
					/>
				</div>
			</div>
			<div className={classes.paragraph}>
				<div className={classes.leftColumn}></div>
				<div className={classes.rightColumn}>
					<TagManager
						tagsData={invoiceTags}
						groups={[i18n.t('provider.companysinvoicing')]}
						showGroupTitles={true}
						onChange={(e) => {
							handleInvoiceChange(e);
							setIsChanged(true);
						}}
						filterObject={providerData.provider_invoicing_filter}
						filterType="array"
					/>
				</div>
			</div>
			{/* <div className={classes.paragraph}>
				<div className={classes.leftColumn}></div>
				<div className={classes.rightColumn}>
					<TagManager
						tagsData={softwareTags}
						groups={[i18n.t('provider.companyssoftware')]}
						showGroupTitles={true}
						onChange={(e) => handleSoftwareChange(e)}
						filterObject={providerData.provider_software_filter}
						filterType='array'
					/>
				</div>
			</div> */}
			{/* <Divider sx={{ margin: '0 18px' }} />
			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('provider.specialindustryfilters')}
					</div>
				</div>
				<div className={classes.rightColumn}>
					<TagManager
						tagsData={specialIndustryTags}
						groups={[i18n.t('provider.specialindustryfilters')]}
						showGroupTitles={false}
						onChange={(e) => handleSpecialIndustryChange(e)}
						filterObject={providerData.provider_special_industry_restrictions}
						filterType='array'
					/>
				</div>
			</div> */}
		</>
	);
};

export default ClientFiltersTab;
